import { getMenu, realLogin } from '@/api/login'
import { login, queryMenus, queryUserInfo, refreshLogin, loginOut } from "@/api/aloneLogin";
import { userInfo } from '@/api/login'
import { setToken, setUserInfo, setRefreshToken } from '@/utils'
import { message } from "ant-design-vue";

const user = {
  state: {
    token: "",
    name: "管理员",
    welcome: "",
    avatar: "",
    roles: [],
    info: {},
    router: [],
  },

  mutations: {
    SET_TOKEN: (state, token) => {
      state.token = token;
    },
    SET_ROLES: (state, roles) => {
      state.roles = roles;
    },
    SET_INFO: (state, info) => {
      state.info = info;
    },
    SET_ROUTER: (state, router) => {
      if (Array.isArray(router)) {
        state.router = router.map(route => ({
          id: route.menuId,
          pid: route.parentMenuId,
          name: route.menuName,
          title: route.menuTitle,
          component: route.component,
          ...route
        }));
      }
    },
  },

  actions: {
    // 登录
    Login({ commit }, userInfo) {
      return new Promise((resolve, reject) => {
        realLogin(userInfo).then((response) => {
          const token = response.data;
          setToken(token);
          commit("SET_TOKEN", token);
          resolve();
        }).catch((error) => {
          reject(error); 
        });
      });
    },
    // 经销商登录
    AccountLogin({ commit }, userInfo) {
      return new Promise((resolve, reject) => {
        login(userInfo).then((response) => {
          const token = response.data.access_token;
          const refreshToken = response.data.refresh_token;
          setToken(token);
          commit("SET_TOKEN", token);
          setRefreshToken(refreshToken);
          resolve();
        }).catch((error) => {
          reject(error);
        });
      });
    },
    // 刷新token
    RefreshToken({ commit }, data) {
      return new Promise((resolve, reject) => {
        refreshLogin(data).then((response) => {
          const token = response.data.access_token;
          const newRefreshToken = response.data.refresh_token;
          
          // 更新本地存储的token
          setToken(token);
          commit("SET_TOKEN", token);
          setRefreshToken(newRefreshToken);
          resolve({
            access_token: token,
            refresh_token: newRefreshToken
          });
        }).catch((error) => {
          reject(error);
        });
      });
    },
    // 获取菜单
    GetMenu({ commit }) {
      return new Promise((resolve, reject) => {
        queryMenus().then((response) => {
          commit("SET_ROUTER", response.data);
          //localStorage.setItem('router', JSON.stringify(response.data));
          resolve(response.data);
        }).catch((error) => {
          reject(error);
        });
      });
    },

    // 获取用户信息
    GetUserInfo({ commit }){
      queryUserInfo().then((res)=>{
        commit("SET_INFO", res.data);
        let roleList = res.data.roleList || [];
        let roles = roleList.map(item => item.roleCode);
        commit("SET_ROLES", roles);
        setUserInfo(res.data);
      }).catch(e=>{
        console.log(e);
      })
    },

    // 登出
    Logout({ commit }) {
      commit("SET_TOKEN", "");
      commit("SET_ROUTER", []);
      localStorage.setItem('router', '[]');
      setToken("");
      setRefreshToken("");
      setTimeout(() => {
        window.location.href = window.location.origin;
      }, 300);
    },
    // 后端登出
    realLogout({ commit }) {
      return new Promise((resolve, reject) => {
        loginOut().then((response) => {
          commit("SET_TOKEN", "");
          commit("SET_ROUTER", []);
          localStorage.setItem('router', '[]');
          setToken("");
          setRefreshToken("");
          setTimeout(() => {
            window.location.href = window.location.origin;
          }, 300);
          resolve(response);
        }).catch((error) => {
          message.error(error.msg || error.errorMsg || error.message || '操作失败');
          reject(error);
        });
      });
    },
  },
};

export default user
